$(document).ready(function () {
  
  var copyMsgInterval;

  $('.shareContainer .copy').on('click', function(e){
    
    e.preventDefault();
    
    $link = window.location.href;
    
    var tempLinkHolder = document.createElement("textarea");
    document.body.appendChild(tempLinkHolder);
    tempLinkHolder.value = $link;
    tempLinkHolder.select();
    document.execCommand("copy");
    document.body.removeChild(tempLinkHolder);
    
    
    $('.status').removeClass('isVisible');
    $('.status.is-copied').addClass('isVisible');
    $('.status.is-copied').removeAttr('style');
    
    pSendGAEvent('share', {'method': 'copy', 'content_type': 'bloglink', 'item_id': $link}, 'blog-2020.js', 'blog-2020.js: BlogCopyLink event gone wrong'); 
    
    clearInterval(copyMsgInterval);
    
    copyMsgInterval = setInterval(function() {
      $('.status.is-copied').fadeOut(500, 'linear');
    }, 3000);
    
  });
  
  $('.closeBox').on('click', function(e){
    e.preventDefault();
    $(this).closest('.isVisible').removeClass('isVisible');
  });
  
  
  $('.shareContainer .shareLink').on('click', function(e){
    
    e.preventDefault();
    
    pSendGAEvent('share', {'method': $(this).data('type'), 'content_type': 'bloglink', 'item_id': $(this).attr('href')}, 'blog-2020.js', 'blog-2020.js: BlogShareLink event gone wrong'); 
    
    window.open($(this).attr('href'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
    return false;

  });
  
  
});

